import { connect } from 'react-redux';
import { AppState } from 'src/store';
import { Footer } from 'src/pages/NavigationShell/Footer/Footer';

function mapStateToProps(state: AppState) {
  const footerTypes = state.appConfig.tenantConfig.footerTypes;

  return {
    footerTypes: footerTypes ?? {},
  };
}

export default connect(mapStateToProps)(Footer);
